
import React, { useState } from 'react';
import './code.css';

const Code = ({ text }) => {
  const [isVariant, setIsVariant] = useState(false);

  return (
    <>

      <div className="code_text">
        <code>{text}</code>
      </div>
    </>

  )
}

export default Code;